var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgThinborder2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1038_6104)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-712.572 527.32H1.2601C1.67338 527.32 2.03745 527.054 2.17521 526.661C5.50108 516.732 13.4123 508.82 23.3407 505.494C23.7343 505.366 24 504.992 24 504.579V22.7414C24 22.3281 23.7343 21.964 23.3407 21.8262C13.4123 18.5001 5.50108 10.5884 2.17521 0.659313C2.04729 0.265693 1.67338 0 1.2601 0H-712.572C-712.985 0 -713.349 0.265693 -713.487 0.659313C-716.813 10.5884 -724.724 18.5001 -734.653 21.8262C-735.046 21.9542 -735.312 22.3281 -735.312 22.7414V504.579C-735.312 504.992 -735.046 505.356 -734.653 505.494C-724.724 508.82 -716.813 516.732 -713.487 526.661C-713.359 527.054 -712.985 527.32 -712.572 527.32ZM0.581154 525.401H-711.883C-715.445 515.423 -723.406 507.462 -733.373 503.91V23.4302C-723.396 19.868 -715.435 11.907 -711.883 1.92874H0.581154C4.14318 11.907 12.1036 19.868 22.0812 23.4302V503.9C12.1036 507.462 4.14318 515.423 0.581154 525.391V525.401Z",
    fill: "#C4944D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1038_6104"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "matrix(-1 0 0 1 24 0)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThinborder2);
export default __webpack_public_path__ + "static/media/Thinborder2.3b4fa638f6b40a74a27870033662b38d.svg";
export { ForwardRef as ReactComponent };